module.exports = __webpack_public_path__ + "img/why.ff2d0627.jpg";